export default {"offerContainer":"HbjFt"};